import {
  AdditionalInfoRecord,
  InformationRecord,
} from "us.collection.debtor/Interfaces";
import _ from "lodash";
import { AdditionalInfoDataTypes, ValueType } from "us.common/constants";

/**
 * @function
 * @description get additional info initial form values
 * @param {number} selectedInfoId selected additional information record id
 * @param {Array} informationList additional information list
 * @returns {object} formatted information object
 */
export const getAdditionalInfoInitFormValues = (
  selectedInfoId: number,
  informationList: Array<AdditionalInfoRecord>
): {
  status: string;
  informationList: Array<InformationRecord>;
} => {
  try {
    if (Array.isArray(informationList)) {
      if (selectedInfoId > -1) {
        const { status, information } =
          _.find(informationList, {
            id: selectedInfoId,
          }) ?? {};
        return {
          status: status ? status : "",
          informationList: Array.isArray(information) ? information : [],
        };
      } else {
        return {
          status: "",
          informationList: [{ key: "", value: "" }],
        };
      }
    } else {
      return {
        status: "",
        informationList: [],
      };
    }
  } catch (error) {
    return {
      status: "",
      informationList: [],
    };
  }
};

/**
 * @function
 * @description - To get the matching data type
 * @param selectedFieldName - Selected field name
 * @param {Array} metaDataList - List of options
 * @return {string}  data type of the selected field
 */
export const getValueDataType = (
  selectedFieldName: any,
  metaDataList: Array<any>
): string => {
  try {
    const { dataType } = _?.find(metaDataList, {
      label: selectedFieldName,
    });

    return dataType;
  } catch (error) {
    return "";
  }
};

/**
 * @function
 * @description - To get the matching default value
 * @param selectedFieldName - Selected field name
 * @param {Array} metaDataList - List of options
 * @return {string}  data type of the selected field
 */
export const getDefaultValue = (
  selectedFieldName: any,
  metaDataList: Array<any>
): string => {
  try {
    const { defaultValue, dataType } = _?.find(metaDataList, {
      label: selectedFieldName,
    });

    return dataType == AdditionalInfoDataTypes.BOOLEAN && !defaultValue
      ? "false"
      : defaultValue;
  } catch (error) {
    return "";
  }
};

/**
 * @function
 * @description - Convert value to proper format
 * @param currentField - current field data
 * @param {Array} metaDataList - List of options
 * @return {string}  data type of the selected field
 */
export const convertValueToProperFormat = (
  currentField: any,
  metaDataList: Array<any>
): string => {
  try {
    const { key, value } = currentField ?? {};
    const { dataType } = _?.find(metaDataList, {
      label: key,
    });

    if (
      dataType == AdditionalInfoDataTypes.BOOLEAN ||
      dataType == AdditionalInfoDataTypes.DECIMAL ||
      dataType == AdditionalInfoDataTypes.INT
    ) {
      return JSON.parse(value);
    } else {
      return value;
    }
  } catch (error) {
    return currentField?.value;
  }
};

/**
 * @function
 * @description - To get the matching value type
 * @param selectedFieldName - Selected field name
 * @param {Array} metaDataList - List of options
 * @return {any}  data type of the selected field
 */
export const getSelectedMetaDataInfo = (
  selectedFieldName: any,
  metaDataList: Array<any>
): any => {
  try {
    const metaData = _?.find(metaDataList, {
      label: selectedFieldName,
    });
    return metaData;
  } catch (error) {
    return "";
  }
};

/**
 * @function
 * @description - Get value source as a list for the selected field
 * @param selectedFieldName - Selected field name
 * @param {Array} metaDataList - List of options
 * @param {any} bmdDataType SP data type
 * @return {Array<any>}  value source of the selected field
 */
export const getValueSource = (
  selectedFieldName: any,
  metaDataList: Array<any>,
  bmdDataType: any
): Array<any> => {
  try {
    const { valueSource, valueType, valueTypeId } = _?.find(metaDataList, {
      label: selectedFieldName,
    });
    if (
      valueType == ValueType.SP &&
      Array.isArray(bmdDataType) &&
      bmdDataType?.length > 0
    ) {
      const { values } = _?.find(bmdDataType, {
        typeId: valueTypeId,
      });
      if (values) {
        return values?.map((item: string) => ({
          label: item.trim(),
          value: item.trim(),
        }));
      } else {
        return [];
      }
    } else {
      return valueSource;
    }
  } catch (error) {
    return [];
  }
};

/**
 * @function
 * @description get additional info initial form values
 * @param {number} selectedInfoId selected additional information record id
 * @param {Array} informationList additional information list
 * @returns {Array<InformationRecord>}
 */
export const getValuesByRecordId = (
  selectedInfoId: number,
  informationList: Array<AdditionalInfoRecord>
): Array<InformationRecord> => {
  try {
    if (Array.isArray(informationList) && selectedInfoId > -1) {
      const { information } =
        _.find(informationList, {
          id: selectedInfoId,
        }) ?? {};
      return Array.isArray(information) ? information : [];
    } else return [];
  } catch (error) {
    return [];
  }
};
